import React from 'react';
import QRCode from 'qrcode.react';
import { useSelector } from 'react-redux';
const QrCodeGenrate = ({ amount, height = "100px", width = "100px" }) => {


    const userDetail = useSelector((state) => state.reducer.userDetail)
    // console.log("amountprint ",amount," ",userDetail?.upiid)
    // const upiPaymentLink = `upi://pay?pa=7499297417@axl&pn=Ankit&am=${amount}&cu=INR&tn=trail`;
    const upiPaymentLink = `upi://pay?pa=${userDetail?.upiid}&pn=${userDetail?.name}&am=${12}&cu=INR&tn=trail`;


    return (

        <QRCode value={upiPaymentLink} style={{ height: height, width: width }} />
    )
}
export default QrCodeGenrate